import React from 'react'

import useDarkMode from 'use-dark-mode'
import cx from 'classnames'

import style from './theme-toggler.module.scss'

const ThemeToggle = (): JSX.Element => {
  const darkMode = useDarkMode(true, {})

  return (
    <>
      <div className={style.theme_toggler}>
        <span className={cx(style.style_toggle, style.nav_link)} onClick={() => darkMode.toggle()}>
          <div className={cx(style.icon, style.sun)} title="Light mode">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              aria-hidden="true"
              className="iconify sun-icon"
              data-icon="feather-sun"
              data-inline="false"
              transform="rotate(360)"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              >
                <circle fill="#ffbb52" cx="12" cy="12" r="5"></circle>
                <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"></path>
              </g>
            </svg>
          </div>
          <div className={cx(style.icon, style.moon)} title="Dark mode">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              aria-hidden="true"
              className="iconify moon-icon"
              data-icon="feather-moon"
              data-inline="false"
              transform="rotate(360)"
              viewBox="0 0 24 24"
            >
              <path
                fill="#101010"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"
              ></path>
            </svg>
          </div>
        </span>
      </div>
    </>
  )
}

export default ThemeToggle
